<div mat-dialog-title class="ds">
  <span>{{ title }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
<div id="formContainer" mat-dialog-content class="content ds">
  <form [formGroup]="productForm">
    <div id="searchFormContent" class="product-container">
      <ds-textfield id="partNumber" class="fill-width" [label]="appStrings.customTool_partNumberLabel" label_orientation="vertical-label" 
        [control]="productForm.controls.partNumber">
      </ds-textfield>
      <div class="multiline-container">
        <ds-multiline id="description" class="fill-width" [label]="appStrings.customTool_descriptionLabel" label_orientation="vertical-label" 
          [control]="productForm.controls.description" (onBlur)="trimDescriptionControl($event.target.value)">
        </ds-multiline>
      </div>
      <ds-textfield id="quantity" class="half-width" [label]="appStrings.products_gridQuantity" label_orientation="vertical-label" 
        [control]="productForm.controls.quantity">
      </ds-textfield>
      <ds-textfield id="unitNetPrice" class="half-width" [label]="appStrings.customTool_unitNetPriceLabel" label_orientation="vertical-label" 
        [control]="productForm.controls.unitNetPrice" start_adornment_type="text" [start_adornment_value_text]="currencySymbol">
      </ds-textfield>
      <div class="multiline-container">
        <ds-multiline id="lineNotes" class="fill-width" [label]="appStrings.products_gridLineNotes" label_orientation="vertical-label" 
          [control]="productForm.controls.lineNotes" maxLength="2000">
        </ds-multiline>
      </div>
    </div>
  </form>
</div>
<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="close(0)"
      [label]="appStrings.button_close">
    </ds-button>
    <ds-button id="addButton" variant="label-only" size="medium" type="primary" (onClick)="saveInfo()" 
      [label]="appStrings.button_save" [isDisabled]="!productForm.valid">
    </ds-button>
  </div>
</div>